/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { IconChevronLeft,   IconEdit } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import NewCommonModal from "../../components/common/NewCommonModal";
import { usePermission } from "../../hooks/usePermissionTabs";
import {
  useDarkStoreUpdateMutation,
  useFetchDarkStoreDetailsData,
} from "../../apis/darkStoreApi";
import AddDarkStoreModal from "./AddDarkStoreModal";

 
export default function ViewDarkStoreDetails() {
  const { id } = useParams();
  const [editDialog, setEditDialog] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] = useState<any>({
    photo: false,
  });

  const Section = ({
    title,
    children,
  }: {
    title?: string;
    children: React.ReactNode;
  }) => (
    <div className="p-4 bg-[#F7F6F2] rounded-3xl border border-[#EFEFEF] space-y-2">
      <div className="grid grid-cols-12 gap-x-6 ">{children}</div>
    </div>
  );

  const { data: darkStoreDetails, refetch: fetchDarkStoreDetails } =
    useFetchDarkStoreDetailsData(id ?? "");

  const { mutate, isPending: isRequestPending } = useDarkStoreUpdateMutation(
    darkStoreDetails?.id ?? "",
  );

  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <div className="text-sm text-[#212121] flex justify-between items-center gap-1 border-b last:border-0 py-3 px-4">
      <p className="capitalize ">{label}:</p>
      <p className="font-medium "> {value}</p>
    </div>
  );

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm<any>();

  useEffect(() => {
    if (id) {
      fetchDarkStoreDetails();
    }
  }, [id]);

  const handleEditDarkStoreToggle = () => {
    setEditDialog(!editDialog);
    if (!editDialog) {
      reset();
    }
  };

  const { allowed: canUpdateDriver, isLoading } = usePermission(
    "drivers",
    "update",
  );

  const handleDarkStoreUpdate = (data: any) => {
    let { photo, ...otherData } = data;
    mutate(
      {
        ...otherData,
        ...(selectedDocument?.photo && { photo: data?.photo }),
      },
      {
        onSuccess: () => {
          setSelectedDocument({
            photo: false,
          });
          fetchDarkStoreDetails();
          handleEditDarkStoreToggle();
          setEditDialog(false);
          // toast.success("Dark Store Update Successfully.");
          navigate("/dark-store");
        },
        onError: (error: any) => {
          toast.error("Failed to update dark store.");
        },
      },
    );
  };

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <img
                src={darkStoreDetails?.photo || "/img/dummy-blank-profile.png"}
                className="w-10 h-10 rounded-full border object-cover"
                alt=""
              />
              <h1 className="text-2xl text-[#212121] tracking-[-0.5px]  ">
                {darkStoreDetails?.storeCode}
              </h1>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <Section title={""}>
            <div className="flex justify-between items-center col-span-12 pb-3 mb-4 lg:mb-0">
              <h3 className="text-[#212121] font-semibold text-lg">
                Store Details{" "}
              </h3>
              {canUpdateDriver && (
                <button
                  onClick={() => {
                    setEditDialog(true);
                  }}
                  className="flex items-center gap-1  p-2.5  text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                >
                  <IconEdit stroke={1.5} size={24} />
                </button>
              )}
            </div>
            <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden col-span-12 lg:col-span-6 mb-4 lg:mb-0">
              <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                Store Info{" "}
              </h3>

              <TwoCol label="Store Name" value={darkStoreDetails?.name} />
              <TwoCol label="Store Code" value={darkStoreDetails?.storeCode} />
              <TwoCol
                label="Contact Person"
                value={darkStoreDetails?.contactPerson}
              />
              <TwoCol label="Mobile" value={darkStoreDetails?.mobileNo} />
              <TwoCol label="Email" value={darkStoreDetails?.email} />
              {/* <TwoCol label="Time Slot" value={darkStoreDetails?.slotName} /> */}
              <TwoCol
                label="Driver Assignment"
                value={darkStoreDetails?.driverAssignmentType}
              />
              {darkStoreDetails?.pickupRadius && (
                <TwoCol
                  label="Pickup Radius"
                  value={`${darkStoreDetails?.pickupRadius} KM`}
                />
              )}
              {darkStoreDetails?.deliveryRadius && (
                <TwoCol
                  label="Delivery Radius"
                  value={`${darkStoreDetails?.deliveryRadius} KM`}
                />
              )}
            </div>
            <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden col-span-12 lg:col-span-6 mb-4 lg:mb-0">
              <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                Address Details
              </h3>
              <div className="grid grid-cols-1 ">
                <TwoCol label="Country" value={darkStoreDetails?.countryName} />
                <TwoCol label="City" value={darkStoreDetails?.cityName} />
                <TwoCol
                  label="District"
                  value={darkStoreDetails?.districtName}
                />
                <TwoCol label="Zip Code" value={darkStoreDetails?.pincode} />
                <TwoCol
                  label="Short Address"
                  value={darkStoreDetails?.shortAddress}
                />
                <TwoCol label="Latitude" value={darkStoreDetails?.latitude} />
                <TwoCol label="Longitude" value={darkStoreDetails?.longitude} />
                <TwoCol label="Address" value={darkStoreDetails?.fullAddress} />
              </div>
            </div>
          </Section>
        </div>
      </div>
      <NewCommonModal
        title={"Edit Dark Store"}
        open={editDialog}
        closeButtonText={"Cancel"}
        onClose={handleEditDarkStoreToggle}
        actionButtonText="Update"
        actionButtonOnClick={handleSubmit(handleDarkStoreUpdate)}
        actionButtonProps={{ disabled: isRequestPending }}
        isPending={isRequestPending}
      >
        <AddDarkStoreModal
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          control={control}
          setSelectedDocument={setSelectedDocument}
          darkStoreData={darkStoreDetails}
        />
      </NewCommonModal>
    </>
  );
}
